import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from './entity';
import { StringToInteger } from './converters/string-to-integer-converter';

@JsonObject('SalesOrderDocuments')
export class SalesOrderDocuments extends Entity {
  @JsonProperty('salesOrderId', String)
  public salesOrderId?: string = undefined;

  @JsonProperty('requiredDocumentId', String)
  public requiredDocumentId?: string = undefined;

  @JsonProperty('name', String)
  public name?: string = undefined;

  @JsonProperty('serialNumber', String)
  public serialNumber?: string = undefined;

  @JsonProperty('displayOrder', StringToInteger)
  public displayOrder?: number = undefined;

  @JsonProperty('customerCanUpload', Boolean, true)
  public customerCanUpload?: boolean = undefined;

  @JsonProperty('uploadablePeriodically', Boolean, true)
  public uploadablePeriodically?: boolean = undefined;

  @JsonProperty('associatedToMachine', Boolean, true)
  public associatedToMachine?: boolean = undefined;

  @JsonProperty('notes', String)
  public notes?: string = undefined;

  @JsonProperty('templateId', String)
  public templateId?: string = undefined;

  // ODV Documents related fields
  @JsonProperty('status', Boolean, true)
  public status?: boolean = undefined;

  @JsonProperty('modifiedDate', String, true)
  public modifiedDate?: string = undefined;

  @JsonProperty('attachmentId', String, true)
  public attachmentId?: string = undefined;

  @JsonProperty('hiddenForCustomerPartner', Boolean, true)
  public hiddenForCustomerPartner?: boolean = undefined;

  public get sodName(): string | undefined {
    return this.name;
  }
  public set sodName(value: string | undefined) {
    this.name = value;
  }
}
